import { Injectable } from "@angular/core";
import { UntypedFormArray, UntypedFormGroup } from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class ValidationErrorHandlerService {

  request: any;
  property: any;
  constructor() { }


  public handleValidationErrors(form: UntypedFormGroup, errObj: any): void {
    for (let property in errObj) {
      if (errObj.hasOwnProperty(property)) {
        // let prop = lowercaseFirstCharacter(property);
        if (form.controls[property]) {
          // single field
          let validationErrorsForFormField = {};
          for (let validationError of errObj[property]) {
            validationErrorsForFormField[validationError.validatorKey] = { errorMessage: validationError.message };
          }
          form.controls[property].setErrors(validationErrorsForFormField);
        }
        else {
          // cross field
          let validationErrorsForForm = {};
          for (let validationError of errObj[property]) {
            validationErrorsForForm[validationError.validatorKey] = true;
          }
          form.setErrors(validationErrorsForForm);
        }
      }
    }
  }

  public handleValidationErrorsForsimpleFormWithArrayResponse(form: UntypedFormGroup, errObj: any): void {
    for (let property in errObj) {
      var newProperty = _.camelCase(property.substring(property.indexOf(".") + 1, property.length));
      if (errObj.hasOwnProperty(property)) {
        // let prop = lowercaseFirstCharacter(property);
        if (form.controls[newProperty]) {
          // single field
          let validationErrorsForFormField = {};
          for (let validationError of errObj[property]) {
            validationErrorsForFormField[validationError.validatorKey] = { errorMessage: validationError.message };
          }
          form.controls[newProperty].setErrors(validationErrorsForFormField);
        }
        else {
          // cross field
          let validationErrorsForForm = {};
          for (let validationError of errObj[property]) {
            validationErrorsForForm[validationError.validatorKey] = true;
          }
          form.setErrors(validationErrorsForForm);
        }
      }
    }
  }
  public handleValidationErrorsArray(form: UntypedFormArray, errObj: any): void {
    for (let property in errObj) {
      let controlName = property.split('.').pop()!;
      var index = +property.slice(property.indexOf('[') + 1, property.lastIndexOf(']'));
      if (errObj.hasOwnProperty(property)) {
        let validationErrorsForFormField = {};
        for (let validationError of errObj[property]) {
          validationErrorsForFormField[validationError.validatorKey] = { errorMessage: validationError.message };
        }
        form.at(index).get(controlName)?.setErrors(validationErrorsForFormField);
      }
      else {
        let validationErrorsForForm = {};
        for (let validationError of errObj[property]) {
          validationErrorsForForm[validationError.validatorKey] = true;
        }
        form.setErrors(validationErrorsForForm);
      }
    }
  }
  public handleValidationErrorsArrayofThirdParty(form: UntypedFormArray, errObj: any): void {
    for (let property in errObj) {
      let propertyName = property.split('.').pop()!;
      let controlName = _.camelCase(propertyName)
      var index = +property.slice(property.indexOf('[') + 1, property.lastIndexOf(']'));
      let errorMessage = errObj[property];
      if (errObj.hasOwnProperty(property)) {
        let validationErrorsForFormField = {};
        validationErrorsForFormField[`${controlName}ValidationError`] = errorMessage;
        form.at(index).get(controlName)?.setErrors(validationErrorsForFormField);
      }
      else {
        let validationErrorsForForm = {};
        for (let validationError of errObj[property]) {
          validationErrorsForForm[validationError.validatorKey] = true;
        }
        form.setErrors(validationErrorsForForm);
      }
    }
  }

  setFormArrayErrors(formArray: UntypedFormArray, errorResponse: any) {
    // Iterate over the form array controls
    formArray.controls.forEach((control, index) => {
      const controlName = `AddSwitchTransactionLogs[${index}].ReferenceNumber`;
      if (errorResponse.hasOwnProperty(controlName)) {
        control.setErrors({ serverError: errorResponse[controlName] });
      }
    });
  }
}

//   public showErrorsInToastr(errObj: any) {
//     let message = ``;
//     for (let field in errObj) {
//       message += `&bull; Form field <b>${capitalizeFirstCharacter(field)}</b> has following errors. <br>`;
//       let sn = 1;
//       for (let error in errObj[field]) {
//         let fieldErrorObj = errObj[field][error];
//         message += `&nbsp &nbsp ${sn}. ${fieldErrorObj.message} <br>`;
//         sn++;
//       }
//     }

//     this._toastr.error(message, 'Form Validation Errors', {
//       enableHtml: true,
//       closeButton: true,
//       disableTimeOut: false
//     });
//   }}
function capitalizeFirstCharacter(s) {
  return s && s[0].toUpperCase() + s.slice(1);
}
